import { format, isToday, isYesterday } from "date-fns";
import { ptBR } from "date-fns/locale";

/** "Hoje" / "Ontem" / "9 jan" (pt-BR) — para listas de atividade */
export function relativeDayLabel(isoDate: string): string {
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return "";
  if (isToday(date)) return "Hoje";
  if (isYesterday(date)) return "Ontem";
  return format(date, "d MMM", { locale: ptBR });
}

/** "Quinta-feira, 12 de junho" — linha de data do hero */
export function todayLongLabel(): string {
  const label = format(new Date(), "EEEE, d 'de' MMMM", { locale: ptBR });
  return label.charAt(0).toUpperCase() + label.slice(1);
}
